var StarsFix = (function() {
	var __private = {
		starsClass : "ratings",
		inputSelect: "input.form-error",
		errorSelect: "span.form-error",

		listener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;

				__private.ratinngReview();
			});
		},

		ratinngReview() {
			var ratings = document.getElementsByClassName(this.starsClass);

			for (let i = 0; i < ratings.length; i++) {
				const r = ratings[i];
				let inp = r.querySelector(this.inputSelect);
				let err = r.querySelector(this.errorSelect);

				if(inp instanceof HTMLInputElement && err instanceof HTMLElement) {
					if(+inp.value > 0) err.style.display = "none";
					else err.style.display = "";
				}
			}
		}
	};

	return {
		init() {
			__private.listener();
		}
	};
})();


(function() {
	document.addEventListener("DOMContentLoaded", function() {
		if(document.getElementById("steps-uid-0")) StarsFix.init();
	});
})();